import { RouterModule } from '@angular/router';
import { VoteComponent } from './components/vote/vote.component';
import { WinnersComponent } from './components/winners/winners.component';

export const GalleryRouting = RouterModule.forChild([
  {
    path: 'vote', component: VoteComponent
  },
  {
    path: 'gallery/:year', component: WinnersComponent
  }
]);
